export const playerName = (player) => {
    if (!player)
        return "";
    let s = player.first_name;
    if (player.last_name && player.last_name.length) {
        s += " " + player.last_name[0];
    }
    if (s)
        return s;
    return player.display_name;
};
export const simplePlayer = (profile) => {
    if (!profile)
        return null;
    return {
        user_id: profile.user_id,
        username: profile.username,
        first_name: profile.first_name,
        last_name: profile.last_name,
        name: playerName(profile),
        dna: profile.dna,
        role: profile.role,
        school: {
            school_name: profile.school ? profile.school.school_name : "",
        },
    };
};
